import * as Yup from 'yup'
import 'yup-phone'
import valid from 'card-validator'
import {isIsraeliIdValid, isValidDate} from './validationUtils'

const requiredText = 'שדה חובה'
const invalidIsraeiId = 'מספר ת.ז לא תקין'
const number = 'יש להקליד ספרות בלבד'
const ccNumber = 'המספר שהוקלד לא תקין'
const email = 'כתובת מייל לא תקינה'
const dateRange = 'תאריך סיום לא יכול להיות לפני תאריך התחלה'
const invalidDate = 'תאריך לא תקין'

const phoneSchema = Yup.string().phone('IL', true, 'מספר הטלפון לא תקין')
const israeliIdSchema = Yup.string().test(
    'check israeli id',
    invalidIsraeiId,
    (value) => isIsraeliIdValid(value)
)

export const creditCardSchema = Yup.object({
    ccNumber: Yup.string()
        .test(
            'test-cc-number',
            ccNumber,
            (value) => valid.number(value).isValid
        )
        .required(requiredText),
    ccExpierd: Yup.string().required(requiredText),
    ccCsv: Yup.number().typeError(number).required(requiredText),
    ccName: Yup.string().required(requiredText),
    ccId: Yup.string()
        .test('check israeli id', invalidIsraeiId, (value) =>
            isIsraeliIdValid(value)
        )
        .required(requiredText),
})

export const clientSchema = Yup.object({
    ClientFirstName: Yup.string().required(requiredText),
    ClientLastName: Yup.string().required(requiredText),
    ClientPhone: phoneSchema.required(requiredText),
    ClientEmail: Yup.string().email(email).required(requiredText),
    ClientId: israeliIdSchema.required(requiredText),
    Profession: Yup.string().max(100, 'מקסימום 100 תווים'),
})

export const periodSelectSchema = Yup.object({
    activitiesFrom: Yup.date().typeError(invalidDate).required(requiredText),
    activitiesTo: Yup.date()
        .typeError(invalidDate)
        .when('from', (from) => {
            console.log('period from', from)
            if (!isValidDate(from)) {
                return Yup.string().typeError(invalidDate)
            }
            console.log('period from valid', from)
            if (from) {
                return Yup.date()
                    .typeError(invalidDate)
                    .min(from, dateRange)
                    .required(requiredText)
            }
        }),
})

export const periodSchema = Yup.object({
    from: Yup.date().typeError(invalidDate).required(requiredText),
    to: Yup.date()
        .typeError(invalidDate)
        .when('from', (from) => {
            if (!isValidDate(from)) {
                return Yup.string().typeError(invalidDate)
            }
            if (from) {
                return Yup.date()
                    .typeError(invalidDate)
                    .min(from, dateRange)
                    .required(requiredText)
            }
        }),
})

export const registerLoginDetailsSchema = Yup.object({
    firstName: Yup.string().required(requiredText),
    lastName: Yup.string().required(requiredText),
    email: Yup.string().email(email).required(requiredText),
    username: phoneSchema.required(requiredText),
})

export const registerSmsVerificationSchema = Yup.object({
    sms: Yup.number(number).typeError(number).required(requiredText),
})

export const registerPasswordSetupSchema = Yup.object({
    password: Yup.string().required(requiredText),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'הסיסמאות אינן זהות')
        .required(requiredText),
})

export const registerUserDetailsSchema = Yup.object({
    id: israeliIdSchema.required(requiredText),
    approvedTerms: Yup.bool().oneOf([true], 'יש לאשר את תנאי השימוש והפרטיות'),
})

export const registerSchema = Yup.object({
    firstName: Yup.string().required(requiredText),
    lastName: Yup.string().required(requiredText),
    email: Yup.string().email(email).required(requiredText),
    username: phoneSchema.required(requiredText),
    sms: Yup.number(number).typeError(number).required(requiredText),
    password: Yup.string().required(requiredText),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'הסיסמאות אינן זהות')
        .required(requiredText),
    id: israeliIdSchema.required(requiredText),
})

export const forgotPasswordSchema = Yup.object({
    username: phoneSchema.required(requiredText),
    password: Yup.string().required(requiredText),
    confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'הסיסמאות אינן זהות')
        .required(requiredText),
})
